export const TEST_MODE_PARAM = 'test';

export function isTestMode()
{
    return new URL(document.location.href).searchParams.get(TEST_MODE_PARAM) !== null;
}
